"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _marshaler = _interopRequireDefault(require("../util/marshaler"));

var _combineStreams = _interopRequireDefault(require("../util/combine-streams"));

var _constants = require("../util/constants");

var _apiKeys = _interopRequireDefault(require("./api-keys"));

var _collaborators = _interopRequireDefault(require("./collaborators"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var Gateways = /*#__PURE__*/function () {
  function Gateways(api, _ref) {
    var defaultUserId = _ref.defaultUserId,
        stackConfig = _ref.stackConfig;
    (0, _classCallCheck2["default"])(this, Gateways);
    this._api = api;
    this._defaultUserId = defaultUserId;
    this._stackConfig = stackConfig;
    this.ApiKeys = new _apiKeys["default"](api.GatewayAccess, {
      parentRoutes: {
        get: 'gateway_ids.gateway_id',
        list: 'gateway_ids.gateway_id',
        create: 'gateway_ids.gateway_id',
        update: 'gateway_ids.gateway_id'
      }
    });
    this.Collaborators = new _collaborators["default"](api.GatewayAccess, {
      parentRoutes: {
        get: 'gateway_ids.gateway_id',
        list: 'gateway_ids.gateway_id',
        set: 'gateway_ids.gateway_id'
      }
    });
  }

  (0, _createClass2["default"])(Gateways, [{
    key: "_emitDefaults",
    value: function _emitDefaults(paths, gateway) {
      // Handle zero coordinates that are swallowed by the grpc-gateway for
      // gateway antennas.
      if (paths.includes('antennas') && Boolean(gateway.antennas)) {
        var antennas = gateway.antennas;

        var _iterator = _createForOfIteratorHelper(antennas),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var antenna = _step.value;

            if (!('altitude' in antenna.location)) {
              antenna.location.altitude = 0;
            }

            if (!('longitude' in antenna.location)) {
              antenna.location.longitude = 0;
            }

            if (!('latitude' in antenna.location)) {
              antenna.location.latitude = 0;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      } // Handle missing boolean values.


      if (paths.includes('location_public') && !Boolean(gateway.location_public)) {
        gateway.location_public = false;
      }

      if (paths.includes('auto_update') && !Boolean(gateway.auto_update)) {
        gateway.auto_update = false;
      }

      if (paths.includes('require_authenticated_connection') && !Boolean(gateway.require_authenticated_connection)) {
        gateway.require_authenticated_connection = false;
      }

      if (paths.includes('update_location_from_status') && !Boolean(gateway.update_location_from_status)) {
        gateway.update_location_from_status = false;
      }

      return gateway;
    } // Retrieval.

  }, {
    key: "getAll",
    value: function () {
      var _getAll = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(params, selector) {
        var response;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this._api.GatewayRegistry.List(undefined, _objectSpread(_objectSpread({}, params), _marshaler["default"].selectorToFieldMask(selector)));

              case 2:
                response = _context.sent;
                return _context.abrupt("return", _marshaler["default"].unwrapGateways(response));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getAll(_x, _x2) {
        return _getAll.apply(this, arguments);
      }

      return getAll;
    }()
  }, {
    key: "getById",
    value: function () {
      var _getById = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(id, selector) {
        var fieldMask, response;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                fieldMask = _marshaler["default"].selectorToFieldMask(selector);
                _context2.next = 3;
                return this._api.GatewayRegistry.Get({
                  routeParams: {
                    'gateway_ids.gateway_id': id
                  }
                }, fieldMask);

              case 3:
                response = _context2.sent;
                return _context2.abrupt("return", this._emitDefaults(fieldMask.field_mask.paths, _marshaler["default"].unwrapGateway(response)));

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getById(_x3, _x4) {
        return _getById.apply(this, arguments);
      }

      return getById;
    }()
  }, {
    key: "search",
    value: function () {
      var _search = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(params, selector) {
        var response;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this._api.EntityRegistrySearch.SearchGateways(undefined, _objectSpread(_objectSpread({}, params), _marshaler["default"].selectorToFieldMask(selector)));

              case 2:
                response = _context3.sent;
                return _context3.abrupt("return", _marshaler["default"].unwrapGateways(response));

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function search(_x5, _x6) {
        return _search.apply(this, arguments);
      }

      return search;
    }() // Update.

  }, {
    key: "updateById",
    value: function () {
      var _updateById = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(id, patch) {
        var mask,
            response,
            _args4 = arguments;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                mask = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : _marshaler["default"].fieldMaskFromPatch(patch, this._api.GatewayRegistry.UpdateAllowedFieldMaskPaths);
                _context4.next = 3;
                return this._api.GatewayRegistry.Update({
                  routeParams: {
                    'gateway.ids.gateway_id': id
                  }
                }, {
                  gateway: patch,
                  field_mask: _marshaler["default"].fieldMask(mask)
                });

              case 3:
                response = _context4.sent;
                return _context4.abrupt("return", this._emitDefaults(mask, _marshaler["default"].unwrapGateway(response)));

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function updateById(_x7, _x8) {
        return _updateById.apply(this, arguments);
      }

      return updateById;
    }() // Creation.

  }, {
    key: "create",
    value: function () {
      var _create = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5() {
        var ownerId,
            gateway,
            isUserOwner,
            routeParams,
            response,
            _args5 = arguments;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                ownerId = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : this._defaultUserId;
                gateway = _args5.length > 1 ? _args5[1] : undefined;
                isUserOwner = _args5.length > 2 && _args5[2] !== undefined ? _args5[2] : true;
                routeParams = isUserOwner ? {
                  'collaborator.user_ids.user_id': ownerId
                } : {
                  'collaborator.organization_ids.organization_id': ownerId
                };
                _context5.next = 6;
                return this._api.GatewayRegistry.Create({
                  routeParams: routeParams
                }, {
                  gateway: gateway
                });

              case 6:
                response = _context5.sent;
                return _context5.abrupt("return", _marshaler["default"].unwrapGateway(response));

              case 8:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function create() {
        return _create.apply(this, arguments);
      }

      return create;
    }() // Deletion.

  }, {
    key: "deleteById",
    value: function () {
      var _deleteById = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(id) {
        var response;
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this._api.GatewayRegistry.Delete({
                  routeParams: {
                    gateway_id: id
                  }
                });

              case 2:
                response = _context6.sent;
                return _context6.abrupt("return", _marshaler["default"].payloadSingleResponse(response));

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function deleteById(_x9) {
        return _deleteById.apply(this, arguments);
      }

      return deleteById;
    }() // Miscellaneous.

  }, {
    key: "getStatisticsById",
    value: function () {
      var _getStatisticsById = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(id) {
        var response;
        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this._api.Gs.GetGatewayConnectionStats({
                  routeParams: {
                    gateway_id: id
                  }
                });

              case 2:
                response = _context7.sent;
                return _context7.abrupt("return", _marshaler["default"].payloadSingleResponse(response));

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function getStatisticsById(_x10) {
        return _getStatisticsById.apply(this, arguments);
      }

      return getStatisticsById;
    }()
  }, {
    key: "getRightsById",
    value: function () {
      var _getRightsById = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8(gatewayId) {
        var result;
        return _regenerator["default"].wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this._api.GatewayAccess.ListRights({
                  routeParams: {
                    gateway_id: gatewayId
                  }
                });

              case 2:
                result = _context8.sent;
                return _context8.abrupt("return", _marshaler["default"].unwrapRights(result));

              case 4:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function getRightsById(_x11) {
        return _getRightsById.apply(this, arguments);
      }

      return getRightsById;
    }() // Events Stream

  }, {
    key: "openStream",
    value: function () {
      var _openStream = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee9(identifiers, tail, after) {
        var _this = this;

        var payload, distinctComponents, streams;
        return _regenerator["default"].wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                payload = {
                  identifiers: identifiers.map(function (id) {
                    return {
                      gateway_ids: {
                        gateway_id: id
                      }
                    };
                  }),
                  tail: tail,
                  after: after
                }; // Event streams can come from multiple stack components. It is necessary to
                // check for stack components on different hosts and open distinct stream
                // connections for any distinct host if need be.

                distinctComponents = this._stackConfig.getComponentsWithDistinctBaseUrls([_constants.STACK_COMPONENTS_MAP.is, _constants.STACK_COMPONENTS_MAP.gs]);
                streams = distinctComponents.map(function (component) {
                  return _this._api.Events.Stream({
                    component: component
                  }, payload);
                }); // Combine all stream sources to one subscription generator.

                return _context9.abrupt("return", (0, _combineStreams["default"])(streams));

              case 4:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function openStream(_x12, _x13, _x14) {
        return _openStream.apply(this, arguments);
      }

      return openStream;
    }() // Gateway Configuration Server.

  }, {
    key: "getGlobalConf",
    value: function () {
      var _getGlobalConf = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee10(gatewayId) {
        var endpoint, response;
        return _regenerator["default"].wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                // Endpoint hardcoded because it is not part of the gRPC API.
                // Refactor implementation once the following issue is resolved:
                // https://github.com/TheThingsNetwork/lorawan-stack/issues/3280
                endpoint = "/gcs/gateways/".concat(gatewayId, "/semtechudp/global_conf.json");
                _context10.next = 3;
                return this._api._connector.handleRequest('get', endpoint, 'gcs', false);

              case 3:
                response = _context10.sent;
                return _context10.abrupt("return", _marshaler["default"].payloadSingleResponse(response.data));

              case 5:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function getGlobalConf(_x15) {
        return _getGlobalConf.apply(this, arguments);
      }

      return getGlobalConf;
    }()
  }]);
  return Gateways;
}();

var _default = Gateways;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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